"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Step, StepIndicator, StepNumber as ChakraStepNumber, StepStatus, StepSeparator, Stepper as ChakraStepper, forwardRef, } from "@chakra-ui/react";
const Stepper = forwardRef(({ steps, index, hideStepNumber }, ref) => {
    const stepNumber = !hideStepNumber ? _jsx(ChakraStepNumber, {}) : null;
    return (_jsx(ChakraStepper, Object.assign({ ref: ref, index: index }, { children: steps.map((step, stepIndex) => (_jsxs(Step, { children: [_jsx(StepIndicator, Object.assign({}, (step.onClick && stepIndex < index
                    ? {
                        as: "button",
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        onClick: () => step.onClick(stepIndex),
                    }
                    : {}), { children: _jsx(StepStatus, { "aria-label": step.title || `step_${stepIndex}`, complete: stepNumber, incomplete: stepNumber, active: stepNumber }) })), _jsx(StepSeparator, {})] }, step.title || `step_${stepIndex}`))) })));
});
Stepper.displayName = "Stepper";
export default Stepper;
//# sourceMappingURL=Stepper.js.map